import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e53be19"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "metadata-group-card mb-3" }
const _hoisted_2 = { class: "metadata-group-card-header d-flex justify-content-between align-items-center px-3 py-2" }
const _hoisted_3 = ["title"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "restart_alt", -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 0,
  class: "metadata-group-card-body px-3 pt-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputCheckboxBoolean = _resolveComponent("InputCheckboxBoolean")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_InputCheckboxBoolean, {
        modelValue: _ctx.enabled,
        label: _ctx.title,
        name: `${_ctx.name} ${_ctx.$t('cms.useMetadataGroup')}`,
        errors: _ctx.errors,
        class: "metadata-group-card-toggle mb-0",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:enabled', $event)))
      }, null, 8, ["modelValue", "label", "name", "errors"]),
      (_ctx.enabled)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "metadata-group-card-reset btn btn-link p-0",
            title: _ctx.$t('cms.resetMetadataGroup'),
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('reset')), ["prevent"]))
          }, _hoisted_5, 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    (_ctx.enabled)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ]))
      : _createCommentVNode("", true)
  ]))
}